import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import Global from '../../../../store/global-selectors';
import { Button } from 'ui-components/components/button';
import { FormattedMessage } from 'react-intl';
import { emptyArray } from 'ui-components/default-props/empty';
import { archiveBatches } from '../../../../store/batches/grid/batches.grid.actions';

const ArchiveBatchButton = ({ disabled = false }) => {
  const dispatch = useDispatch();
  const selectedBatches = useSelector(Global.selectBatchesSelectedBatches) || emptyArray;
  const fulfillmentPlanSetIds = selectedBatches.map((batch) => batch.fulfillmentPlanSetId);
  return (
    <Button disabled={disabled} onClick={() => dispatch(archiveBatches(fulfillmentPlanSetIds))} theme='tertiary'>
      <FormattedMessage defaultMessage='Archive Batch' description='batchGrid.archiveBatch' id='XoqSMt' />
    </Button>
  );
};

ArchiveBatchButton.propTypes = {
  disabled: PropTypes.bool,
};

export default ArchiveBatchButton;
